import { FormDialog } from "components/dialog/form"
import { MatchingCondition } from "../types"
import { SisetuMatchingConditionForm, useSisetuMatchingConditionForm } from "../form/condition"

type MatchingConditionDialogProps = {
	condition?: MatchingCondition
	onSubmit: (param: MatchingCondition) => void
	onClose: () => void
}
export const MatchingConditionDialog = ({
	condition,
	onSubmit,
	onClose
}: MatchingConditionDialogProps) => {
  const form = useSisetuMatchingConditionForm({ condition, onSubmit })
	return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="名寄せ条件を指定"
      body={<SisetuMatchingConditionForm {...form}/>}
      submitLabel="実行"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}